module.exports = __webpack_public_path__ + "img/04CC77_0CF7CA_04E9A7_04AB54-256px.599bad69.png";